import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.alfredChatbot.enabled) {
  const script = document.createElement('script');
  script.src = 'https://alfred-mini.stg.mta-nprd.cloud.bpifrance.fr/chatbot-v.42.js?agent=agent-manotif';
  script.async = true;
  document.head.appendChild(script);
}

bootstrapApplication(AppComponent,
  appConfig)
  .catch((err) => console.error(err));
